import * as React from 'react';
import { styled } from '@linaria/react';

import usePrefersReducedMotion from '@/hooks/use-prefers-reduced-motion';
import useInterval from '@/hooks/use-interval';
import { normalize, range } from '@/utils';

import Demo, { DemoSliderControl } from '@/components/Demo';

const DemoWrapper = () => {
  const prefersReducedMotion = usePrefersReducedMotion();

  const MIN_SPEED = 1;
  const MAX_SPEED = 5;
  return (
    <Demo
      id="old-rainbow-method"
      initialValues={{ speed: 3 }}
      controlPosition="top"
      customGrid={{
        gridTemplateColumns: 'min(360px, 100%)',
        justifyContent: 'center',
      }}
      controls={[
        <DemoSliderControl
          key="speed"
          id="speed"
          label="Speed"
          min={MIN_SPEED}
          max={MAX_SPEED}
          step={0.5}
        />,
      ]}
    >
      {({ speed }) => {
        const delay = normalize(speed, MIN_SPEED, MAX_SPEED, 300, 60);

        return (
          <CasinoLights
            delay={prefersReducedMotion ? 10000000 : delay}
          />
        );
      }}
    </Demo>
  );
};

const CasinoLights = ({ delay }: { delay: number }) => {
  const TOTAL_NUM_OF_LIGHTS = 7;
  const [activeLight, setActiveLight] = React.useState(0);

  useInterval(() => {
    setActiveLight((activeLight + 1) % TOTAL_NUM_OF_LIGHTS);
  }, delay);

  return (
    <>
      {range(0, TOTAL_NUM_OF_LIGHTS - 1).map((i) => (
        <LightSocket key={i}>
          <Light
            data-status={activeLight === i ? 'on' : 'off'}
            style={{ transition: `opacity ${delay * 0.9}ms` }}
          />
        </LightSocket>
      ))}
    </>
  );
};

const LightSocket = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin: 10px;
  background: hsl(0deg, 0%, 10%);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Light = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: radial-gradient(
    circle at top,
    hsl(55deg, 100%, 100%),
    hsl(55deg, 100%, 70%)
  );
  border: 3px solid hsl(0deg, 0%, 10%);
  box-shadow: 0px 4px 10px hsla(55deg, 100%, 90%, 0.2);

  &[data-status='off'] {
    opacity: 0;
  }
`;

export default DemoWrapper;
